import styled from 'styled-components';
import Logo from '../../elements/Logo';
import BodyText from '../../elements/BodyText';
import Footer from '../../elements/Footer';
import AppLink from '../../elements/AppLink';
import ExternalLink from '../../elements/ExternalLink';
import SocialPageButton from '../SocialPageButton';
import { TABLET, MOBILE } from '../../constants';
var CustomizedFooter = styled(Footer).withConfig({
  displayName: "StyledFooterstyles__CustomizedFooter",
  componentId: "pantheon__fcpamm-0"
})(["box-sizing:border-box;padding:1.75rem;font-family:", ";background-color:", ";color:", ";display:flex;flex-direction:column;bottom:0;position:relative;a{color:", ";}p{color:", ";}@media (max-width:", "){justify-content:center;align-items:center;text-align:center;padding-top:1.5rem;padding-bottom:2rem;}"], function (props) {
  return props.font;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
}, function (props) {
  return props.textColor;
}, function (props) {
  return props.textColor;
}, TABLET);
var SocialButtons = styled(SocialPageButton).withConfig({
  displayName: "StyledFooterstyles__SocialButtons",
  componentId: "pantheon__fcpamm-1"
})(["width:2.1875rem;height:2.1875rem;margin-right:1rem;:last-child{margin-right:0;}"]);
var SocialButtonContainer = styled.div.withConfig({
  displayName: "StyledFooterstyles__SocialButtonContainer",
  componentId: "pantheon__fcpamm-2"
})(["display:inline-flex;justify-content:space-between;align-items:center;text-align:center;p{margin-right:1rem;}"]);
var LinkContainer = styled.div.withConfig({
  displayName: "StyledFooterstyles__LinkContainer",
  componentId: "pantheon__fcpamm-3"
})(["display:flex;justify-content:flex-start;flex-wrap:wrap;a:last-child{padding-right:0;border-right:none;}@media (max-width:", "){justify-content:center;}"], TABLET);
var StackedContainer = styled.div.withConfig({
  displayName: "StyledFooterstyles__StackedContainer",
  componentId: "pantheon__fcpamm-4"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:2rem;img{max-width:6.25rem;max-height:3.25rem;}"]);
var FaviconContainer = styled.div.withConfig({
  displayName: "StyledFooterstyles__FaviconContainer",
  componentId: "pantheon__fcpamm-5"
})(["display:flex;justify-content:center;align-items:center;"]);
var LogoFavicon = styled(Logo).withConfig({
  displayName: "StyledFooterstyles__LogoFavicon",
  componentId: "pantheon__fcpamm-6"
})(["width:auto;height:1.75rem;margin:0.625rem;@media (max-width:", "){padding:0;height:2.8125rem;width:auto;}@media (max-width:", "){height:2.8125rem;width:auto;}"], TABLET, MOBILE);
var CopyrightText = styled(BodyText).withConfig({
  displayName: "StyledFooterstyles__CopyrightText",
  componentId: "pantheon__fcpamm-7"
})(["font-weight:400;font-size:0.8125rem;margin:0;white-space:nowrap;"]);
var Link = styled(AppLink).withConfig({
  displayName: "StyledFooterstyles__Link",
  componentId: "pantheon__fcpamm-8"
})(["margin:0.5rem 1rem 0.5rem 0;padding-right:1rem;border-right:1px solid ", ";font-weight:400;font-size:0.8125rem;letter-spacing:1px;color:", ";white-space:nowrap;"], function (props) {
  return props.textColor;
}, function (props) {
  return props.textColor;
});
var OutsideLink = styled(ExternalLink).withConfig({
  displayName: "StyledFooterstyles__OutsideLink",
  componentId: "pantheon__fcpamm-9"
})(["margin:0.5rem 1rem 0.5rem 0;padding-right:1rem;border-right:1px solid ", ";font-weight:400;font-size:0.8125rem;letter-spacing:1px;color:", ";white-space:nowrap;"], function (props) {
  return props.textColor;
}, function (props) {
  return props.textColor;
});
var SocialLogoContainer = styled.div.withConfig({
  displayName: "StyledFooterstyles__SocialLogoContainer",
  componentId: "pantheon__fcpamm-10"
})(["display:flex;margin:0.5rem 0;align-items:", ";justify-content:space-between;flex-direction:", ";@media (max-width:", "){flex-direction:column;justify-content:flex-start;align-items:center;}"], function (props) {
  return props.hasStackedLogo ? 'flex-start' : 'center';
}, function (props) {
  return props.hasStackedLogo ? 'column' : 'row';
}, TABLET);
export { SocialButtonContainer, LinkContainer, StackedContainer, FaviconContainer, LogoFavicon, CopyrightText, CustomizedFooter, SocialButtons, Link, OutsideLink, SocialLogoContainer };